(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });

    // Store menu smooth scroll handler
    $(document).on('click', 'a', function(e) {
      var href = $(this).attr('href') || '';
      var text = $(this).text().trim().toLowerCase();
      
      // Target links referencing #store-section or matching Store navigation titles
      var isStoreLink = false;
      if (href.indexOf('#store-section') > -1) {
        isStoreLink = true;
      } else if (text === 'store' || text === 'stores' || text === 'our store' || text === 'our stores') {
        // Only trigger for navigation elements (header, mobile menu, sticky menu)
        if ($(this).closest('.main-menu, header, .main-menu-area, .mobile-sticky-menu').length > 0) {
          isStoreLink = true;
        }
      }
      
      if (isStoreLink) {
        var targetEl = document.getElementById('store-section');
        if (targetEl) {
          e.preventDefault();
          
          // Close mobile menu if active
          $(".main-menu-area").removeClass("active");
          $(".mm-fullscreen-bg").removeClass("active");
          $("body").removeClass("ov-hidden");
          
          // Calculate offset to account for sticky header
          var header = $('.header-area');
          var offset = header.length ? header.outerHeight() : 0;
          var targetPosition = $(targetEl).offset().top - offset;
          
          $('html, body').animate({
            scrollTop: targetPosition
          }, 450);
          
          // Update URL hash without causing standard jump
          if (history.pushState) {
            history.pushState(null, null, '#store-section');
          } else {
            location.hash = '#store-section';
          }
        } else {
          // If we are not on the homepage, redirect to the homepage anchor
          if (href === '#' || href === '') {
            e.preventDefault();
            window.location.href = '/#store-section';
          }
        }
      }
    });

    // If coming from another page with #store-section hash, scroll smoothly on load
    if (window.location.hash === '#store-section') {
      setTimeout(function() {
        var targetEl = document.getElementById('store-section');
        if (targetEl) {
          var header = $('.header-area');
          var offset = header.length ? header.outerHeight() : 0;
          var targetPosition = $(targetEl).offset().top - offset;
          $('html, body').animate({
            scrollTop: targetPosition
          }, 450);
        }
      }, 300); // 300ms delay to ensure DOM and styles are fully loaded
    }
  });
})(jQuery);

function formatIndianPrice(priceText) {
  // Extract the numeric value from the price string
  let numericValue = priceText.replace(/[^0-9.,]/g, '');
  let currencySymbol = priceText.match(/[₹$£€]/)?.[0] || '₹';

  // Remove existing formatting and decimals
  numericValue = numericValue.replace(/,/g, '').split('.')[0];

  // Indian number formatting (lakhs and crores)
  let lastThree = numericValue.substring(numericValue.length - 3);
  let otherNumbers = numericValue.substring(0, numericValue.length - 3);

  if (otherNumbers !== '') {
    lastThree = ',' + lastThree;
  }

  let formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

  return currencySymbol + formatted;
}

document.addEventListener('DOMContentLoaded', function () {
  // Format all price elements (runs once for the whole page, regardless of how many
  // product/price snippets were rendered)
  document.querySelectorAll('.new-price, .old-price, .price-item, .unit-price span').forEach(function (el) {
    if (el.textContent.trim()) {
      el.textContent = formatIndianPrice(el.textContent);
      el.classList.add('indian-price');
    }
  });
});